import { Segment, Header, Table } from 'semantic-ui-react';
import { ReconciliationEvent } from '../../../pages/admin/company/stores/peersReportsStore';

type ReconciliationsPropsType = {
    reconciliationEvents: ReconciliationEvent[];
    descriptorsMap: Record<string, any>;
};
function Reconciliations({ descriptorsMap, reconciliationEvents }: ReconciliationsPropsType) {
    return (
        <Segment>
            <Header as="h5">Reconciliations</Header>
            <Table celled structured selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Field Label</Table.HeaderCell>
                        <Table.HeaderCell>Property</Table.HeaderCell>
                        <Table.HeaderCell>Current Value</Table.HeaderCell>
                        <Table.HeaderCell>Target Value</Table.HeaderCell>
                        <Table.HeaderCell>Operation</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {reconciliationEvents.map((event, index) => (
                        <Table.Row key={index}>
                            <Table.Cell>{descriptorsMap[event.descriptorId]?.label ?? 'UNKNOWN'}</Table.Cell>
                            <Table.Cell>{event.property}</Table.Cell>
                            <Table.Cell>{event.currentValue}</Table.Cell>
                            <Table.Cell>{event.targetValue}</Table.Cell>
                            <Table.Cell>{event.operation}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </Segment>
    );
}

export default Reconciliations;
